import { useQuery } from '@tanstack/react-query';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Response {
  id: string;
  isVisible: boolean;
  title: string;
  body: string;
  gymHasAdminCoach: boolean;
}

/**
 * 코치 - 공지사항 가져오기
 * @link https://api-dev.fibud.kr/api#/%ED%97%AC%EC%8A%A4%EC%9E%A5/GymsController_findCoachesGymNotices
 * @param param0
 * @returns
 */
export default function useCoachNoticeQuery() {
  return useQuery([queryKeys.SCHEDULE, 'notice'], () =>
    fetcher<Response>('/gyms/notice')
  );
}
